import fetch from '../fetch';

const path = process.env.VUE_APP_CUSTOMER_SERVER_URL;
export const fetchUserBaseInfo = entity =>
  fetch({
    url: path + '/dcxy/customerInfo/baseInfo',
    params: entity,
  });

export const fetchUserBaseInfoByPhone = entity =>
  fetch({
    url: path + '/dcxy/customerInfo/baseCustomer',
    params: entity,
  });
export const fetchUserAccount = entity =>
  fetch({
    url: path + '/dcxy/customerInfo/queryAccount',
    params: entity,
  });
